import Vue from 'vue';
import App from './app.vue';
import router from './router';
import store from './store';
import VueMeta from 'vue-meta';
import gtm from 'vue-gtm';
import Fragment from 'vue-fragment';
import PortalVue from 'portal-vue';
import appConfigs from '@/classes/app-configs';
import oidcUser from '@/store/oidc-user/oidc-user';

appConfigs().then(appConfigs => {
	store.dispatch('app/setAppConfigsAction', appConfigs);
	store.dispatch('user/setAppConfigsAction', appConfigs);
	store.dispatch('hub/setParentAppStoreAction', store);

	//initializes logging of console events and error events to the logging api
	store.dispatch(
		'logging/initConsoleEventLoggingAction',
		store.getters['app/VUE_APP_CONSOLE_LOG_EVENT_LEVEL']
	);

	store.registerModule('oidcStore', oidcUser);

	Vue.config.productionTip = false;
	Vue.use(VueMeta);
	Vue.use(Fragment.Plugin);
	Vue.use(PortalVue);

	Vue.use(gtm, {
		id: store.getters['app/VUE_APP_GTM_ID'],
		queryParams: {
			gtm_auth: store.getters['app/VUE_APP_GTM_AUTH'],
			gtm_preview: store.getters['app/VUE_APP_GTM_ENV'],
			gtm_cookies_win: 'x'
		},
		enabled: true
	});

	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount('#app');
});
